import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts';

const ProtectedRoute = ({ children, requireRole }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireRole && (!user.roles || !user.roles.includes(requireRole))) {
    return <Navigate to="/markets" replace />;
  }

  return children;
};

export default ProtectedRoute;
